import { Box, Typography, useTheme } from "@mui/material";

const EmptyState = ({ searchTerm }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
      <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
        {searchTerm ? "No strategies found matching your search." : "No strategies available."}
      </Typography>
    </Box>
  );
};

export default EmptyState;
